import 'babel-polyfill'
import 'classlist-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import ViewUI from 'view-design';
import '../static/iview.css';
Vue.use(ViewUI);

import Meta from 'vue-meta';
Vue.use(Meta)


import Header from "./components/Header";
import Footer from "./components/Footer";
Vue.component("Header", Header);
Vue.component("Footer", Footer);


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js